import api from "Helpers/Api";

export default async function campaignDisable(campaignId: string) {
  const { data } = await api.put(`/campaign/disable/${campaignId}`);

  return data;
}
